import React from 'react';

const Comingsoon = () => {
  return (
    <div className="w-full flex items-center justify-center py-24 px-4">
      <h1 className="text-4xl sm:text-6xl md:text-8xl font-extrabold text-[#2d201c] tracking-wide text-center drop-shadow-lg">
        Coming Soon
      </h1>
    </div>
  );
};

export default Comingsoon;
